import React, { useEffect, useState } from "react";
import { ContainerIframe, ContainerNotify } from "./NotifyContainer.styled";

const NotifyContainer = ({ getAccessToken }) => {
  const [productId] = useState("ND3rYXJYEG");
  const [newToken, setNewToken] = useState();

  useEffect(() => {
    getAccessToken(JSON.parse(process.env.SCOPES))
      .then((response) => response)
      .then(
        (value) => {
          if (value) {
            setNewToken(value);
          }
        },
        (error) => {}
      );
  }, []);

  const iframe = `<iframe title="Notify" src="https://tpntadmuidev.z20.web.core.windows.net/auth/login?adToken=${newToken}&productId=${productId}" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>`;

  return (
    <ContainerNotify>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerNotify>
  );
};

export default NotifyContainer;
